/**
 * Application configuration with external override support
 * Can be overridden via window.__APP_CONFIG__
 */

export interface AppConfig {
  API_BASE_URL: string;
  DATA_ADAPTER: "externalApi" | "supabase";
  TENANT_RESOLVER: "subdomain" | "path";
  FEATURE_FLAGS: {
    pwa: boolean;
    ai: boolean;
    offline: boolean;
    trialMode: "disabled" | "enabled";
  };
}

const defaultConfig: AppConfig = {
  API_BASE_URL: "/api",
  DATA_ADAPTER: "supabase",
  TENANT_RESOLVER: "subdomain",
  FEATURE_FLAGS: {
    pwa: true,
    ai: false,
    offline: true,
    trialMode: "enabled", // "disabled" = fallback seguro, "enabled" = chama app_start_trial
  },
};

// Allow runtime override via window object
declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

export function getConfig(): AppConfig {
  if (typeof window !== "undefined" && window.__APP_CONFIG__) {
    return {
      ...defaultConfig,
      ...window.__APP_CONFIG__,
      FEATURE_FLAGS: {
        ...defaultConfig.FEATURE_FLAGS,
        ...(window.__APP_CONFIG__.FEATURE_FLAGS || {}),
      },
    };
  }
  return defaultConfig;
}

export const config = getConfig();
